import { useEffect, useState } from "react";

const STORAGE_KEY = "pds_offer_deadline";
const DURATION_SECONDS = 19 * 60 + 57;

function getDeadline(): number {
  const now = Date.now();
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored && Number(stored) > now) return Number(stored);
    const deadline = now + DURATION_SECONDS * 1000;
    window.sessionStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  } catch {
    return now + DURATION_SECONDS * 1000;
  }
}

export function useCountdown() {
  const [deadline] = useState(getDeadline);
  const [secondsLeft, setSecondsLeft] = useState(() =>
    Math.max(0, Math.round((deadline - Date.now()) / 1000))
  );

  useEffect(() => {
    const id = window.setInterval(() => {
      const left = Math.max(0, Math.round((deadline - Date.now()) / 1000));
      setSecondsLeft(left);
      if (left === 0) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);

  return secondsLeft;
}
